import { Link } from "@tanstack/react-router";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BOOKING_URL, CONTACT_PATH, routeTo } from "@/lib/site";
import { Reveal } from "../Reveal";

const STEPS = [
  {
    n: "01",
    title: "Tell Us About Your Group",
    body: "Share the expected number of guests, preferred dates, accommodation needs, and reason for visiting.",
  },
  {
    n: "02",
    title: "Explore Your Stay Options",
    body: "Review the available RV sites, cabins, motel rooms, efficiency accommodations, and tent camping.",
  },
  {
    n: "03",
    title: "Confirm Current Availability",
    body: "Contact the park or use BookMySites to review options for your preferred dates.",
  },
] as const;

export function GroupPlanning() {
  return (
    <section className="bg-surface py-24 sm:py-28 lg:py-32" aria-labelledby="planning-title">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <p className="eyebrow text-clay">Group Stays</p>
          <h2
            id="planning-title"
            className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
          >
            Planning a Visit With a Group?
          </h2>
        </Reveal>

        <ol className="mt-14 grid gap-8 lg:grid-cols-3 lg:gap-10">
          {STEPS.map((step, i) => (
            <Reveal as="li" key={step.n} delay={i * 0.08} y={22}>
              <div className="rule-sand h-full pt-6">
                <p className="font-display text-sm tracking-[0.18em] text-sand" aria-hidden="true">
                  {step.n}
                </p>
                <h3 className="mt-4 font-display text-2xl text-forest-deep">{step.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {step.body}
                </p>
              </div>
            </Reveal>
          ))}
        </ol>

        <Reveal delay={0.16} className="mt-12 flex flex-wrap gap-4">
          <Button asChild variant="forest" size="cta">
            <Link to={routeTo(CONTACT_PATH)}>
              Contact the Park <ArrowRight aria-hidden="true" />
            </Link>
          </Button>
          <Button asChild variant="outlineForest" size="cta">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              Check Availability <ArrowUpRight aria-hidden="true" />
            </a>
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
